module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.imageModalData && _vm.imageModalData.magnifyImg) ? _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modalcon"
  }, [_c('div', {
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container d-flex justify-content-center"
  }, [_c('div', {
    staticClass: "main-img prelative"
  }, [_c('div', {
    staticClass: "closebtn",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('img', {
    attrs: {
      "data-src": _vm.imageModalData.magnifyImg,
      "alt": _vm.imageModalData.alt || 'Size Chart'
    }
  })])])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fd5be2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/sizeimageModal.vue
// module id = 1482
// module chunks = 14 18